const  unique = [`codeforces.com`,`atcoder.jp`,`codechef.com`,`hackerearth.com`,`leetcode.com`,`topcoder.com`,`codingcompetitions.withgoogle.com`,`spoj.com`];
const  API_URL =  'https://script.google.com/macros/s/AKfycbzeaLxWh-51mxv2C8Kib31esBtDQaSpBRcouFjyDmaojftGNLu2/exec' ;

export {unique,API_URL};